import React from 'react';
import cx from 'classnames';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';

import '../../../PropertyCarousel/Cards/LoadingCard/LoadingCard.less';

export default function LoadingDestinationCard({cardSizeSm = true}) {
    const classNames = {
        cardClassNames: cx('recommended-hit__destination', 'loading-card', {
            'loading-card--sm': cardSizeSm,
        }),
        propertyDetailsClassNames: cx('loading-card__property-details', {
            'loading-card__property-details--sm': cardSizeSm,
        }),
        titleClassNames: cx('loading-card__title', {
            'loading-card__title--sm': cardSizeSm,
        }),
    };

    return (
        <div className={classNames.cardClassNames} data-wdio="loading-card">
            <AspectRatioCard aspectRatio={'3x2'}>
                <div className="loading-card__img" data-slot="figure" />
                <div
                    className="loading-card__destination"
                    data-slot="content"
                />
            </AspectRatioCard>
        </div>
    );
}
